import React, { useCallback, useEffect } from "react";

import { Button, Col, Row } from "react-bootstrap";

import { useAuthenticator } from "@aws-amplify/ui-react";
import classNames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { ROUTES } from "src/routes";

import { CheckCircleSolidGreenIcon } from "@assets/icons";
import { Loading } from "@components/loading";
import { useGetAuthContext } from "@context/useGetAuthContext";
import { useIsInternalUserCreatingAccount } from "@pages/register/hooks/useIsInternalUserCreatingAccount";

import styles from "./RegisterSuccess.module.scss";

export const RegisterSuccess = () => {
  const { authStatus } = useAuthenticator((context) => [context.user]);
  const isAuthenticated = authStatus === "authenticated";

  const location = useLocation();
  const participantId = location.state?.participantId;
  const isInternalUserCreatingAccount = useIsInternalUserCreatingAccount();

  const { authContext, loading, refetch } = useGetAuthContext(
    isAuthenticated,
    true,
    participantId && isInternalUserCreatingAccount,
  );

  const navigate = useNavigate();

  useEffect(() => {
    refetch();
  }, [refetch]);

  const onClickHandler = useCallback(() => {
    refetch();
    if (participantId && isInternalUserCreatingAccount) {
      navigate(ROUTES.Dashboard.Profile.buildPath({ participantId }));
    } else if (authContext?.userGroups) {
      navigate(ROUTES.Dashboard.path);
    }
  }, [authContext?.userGroups, isInternalUserCreatingAccount, navigate, participantId, refetch]);

  // Decide content based on user type and participantId
  const getMessage = () => {
    if (isInternalUserCreatingAccount && participantId) {
      return "The new account has been successfully created. You can now view and manage the account details.";
    } else {
      return "Thanks for registering your details with us. Now let’s take you to your personal dashboard.";
    }
  };

  const getHeading = () => {
    if (isInternalUserCreatingAccount && participantId) {
      return "Account Created Successfully!";
    } else {
      return "You’re Registered!";
    }
  };

  const getButtonText = () => {
    if (isInternalUserCreatingAccount && participantId) {
      return "Go to Account Profile";
    } else {
      return "Go to Dashboard";
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={classNames(styles["container"])}>
      <Row>
        <Col>
          <ReactSVG className={classNames(styles["img"], "mb-2")} src={CheckCircleSolidGreenIcon} />
        </Col>
      </Row>
      <Row className="text-center">
        <h3>{getHeading()}</h3>
      </Row>

      <Row className="text-center">
        <p className={classNames(styles["message"], "b3")}>{getMessage()}</p>
      </Row>

      <Row className="text-center">
        <Col>
          <Button onClick={onClickHandler}>{getButtonText()}</Button>
        </Col>
      </Row>
    </div>
  );
};
